var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.disableHeader ? _c("app-header") : _vm._e(),
      _c(
        "section",
        [
          !_vm.disableMenuLeft ? _c("left-menu") : _vm._e(),
          _vm.showMenu
            ? _c("div", {
                staticClass: "mask",
                on: {
                  click: function($event) {
                    return _vm.onClickMask()
                  }
                }
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "mainpanel",
              class: {
                "no-left": _vm.disableMenuLeft,
                pd0: _vm.disableHeader,
                ml0: !_vm.showMenu,
                ml220: _vm.showMenu
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "contentpanel",
                  class: { pd0: _vm.disableHeader }
                },
                [_c("bread-crumb"), _c("router-view")],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("notifications", {
        attrs: {
          group: "foo",
          position: "top center",
          classes: "hpo-notification",
          width: "350"
        }
      }),
      _vm.isConfirm
        ? _c("confirm-modal", {
            attrs: {
              content: _vm.noteForCustomer,
              textCenter: false,
              textRed: false,
              showNextButton: false
            },
            on: {
              eventCloseModal: function($event) {
                return _vm.onCloseModal($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }